import { render } from "./AppMenu.vue?vue&type=template&id=16a44695"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/menu/AppMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16a44695"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16a44695', __exports__)) {
    console.log('reload')
    api.reload('16a44695', __exports__)
  }
  
  module.hot.accept("./AppMenu.vue?vue&type=template&id=16a44695", () => {
    console.log('re-render')
    api.rerender('16a44695', render)
  })

}


export default __exports__